import { defineMessages } from 'react-intl'

const messages = defineMessages({
  publishedOldest: {
    defaultMessage: 'Published: Oldest'
  },
  publishedNewest: {
    defaultMessage: 'Published: Newest'
  },
  priceLowToHigh: {
    defaultMessage: 'Price: Low to High'
  },
  priceHighToLow: {
    defaultMessage: 'Price: High to Low'
  }
})

export const sortingProductsOptions = [
  {
    label: messages.publishedNewest,
    value: 'newest_published'
  },
  {
    label: messages.publishedOldest,
    value: 'oldest_published'
  },
  {
    label: messages.priceLowToHigh,
    value: 'price_low_to_high'
  },
  {
    label: messages.priceHighToLow,
    value: 'price_high_to_low'
  }
]
